// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t8d4","toggle":"styles_toggle__3j0Jb","preview":"styles_preview__-WK6n"};